import React from 'react'

import Box from 'components_new/atoms/Box'
import Skeleton from 'components_new/atoms/Skeleton'

const Loading = () => {
  return (
    <>
      <Box sx={{ mb: 1 }}>
        <Skeleton variant="rounded" height={128} width={'100%'} />
      </Box>
      <Box>
        {[1, 2, 3, 4].map((item) => (
          <Skeleton
            key={item}
            variant="rounded"
            width={'100%'}
            height={48}
            sx={{ mb: 1 }}
          />
        ))}
      </Box>
    </>
  )
}

Loading.displayName = 'Loading'

export default Loading
